import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { permissoesAdminService } from '../services/permissoesAdminService';
import type { GrupoMenu, PermissaoFormulario } from '../types';

export function usePerfisLista() {
  const { data: perfis = [], isLoading } = useQuery({
    queryKey: ['perfis-lista'],
    queryFn:  permissoesAdminService.listarPerfis,
  });
  return { perfis, isLoading };
}

export function usePermissoesPerfil(perfilId: number | null) {
  const queryClient = useQueryClient();

  const { data: formularios = [], isLoading } = useQuery({
    queryKey: ['permissoes-perfil', perfilId],
    queryFn:  () => permissoesAdminService.buscarPermissoesDoPerfil(perfilId!),
    enabled:  !!perfilId,
  });

  const gruposPorMenu: GrupoMenu[] = Object.values(
    formularios.reduce((acc, f) => {
      if (!acc[f.menuId]) {
        acc[f.menuId] = { menuId: f.menuId, nomeMenu: f.nomeMenu, formularios: [] };
      }
      acc[f.menuId].formularios.push(f);
      return acc;
    }, {} as Record<number, GrupoMenu>)
  );

  const invalidar = () =>
    queryClient.invalidateQueries({ queryKey: ['permissoes-perfil', perfilId] });

  const { mutate: salvarPermissao } = useMutation({
    mutationFn: ({
      formularioId,
      permissao,
    }: {
      formularioId: number;
      permissao: Pick<PermissaoFormulario, 'podeLer' | 'podeIncluir' | 'podeEditar' | 'podeExcluir'>;
    }) => permissoesAdminService.salvarPermissao(perfilId!, formularioId, permissao),
    onSuccess: invalidar,
    onError:   () => toast.error('Erro ao salvar permissão'),
  });

  const { mutate: salvarPorMenu } = useMutation({
    mutationFn: ({ menuId, concederTudo }: { menuId: number; concederTudo: boolean }) =>
      permissoesAdminService.salvarPorMenu(perfilId!, menuId, concederTudo),
    onSuccess: () => { invalidar(); toast.success('Módulo atualizado'); },
    onError:   () => toast.error('Erro ao atualizar módulo'),
  });

  return { gruposPorMenu, isLoading, salvarPermissao, salvarPorMenu };
}
